var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8645 11.809H12.0515L11.7633 11.5312C12.7719 10.3579 13.3791 8.83476 13.3791 7.17782C13.3791 3.48314 10.3842 0.488281 6.68954 0.488281C2.99485 0.488281 0 3.48314 0 7.17782C0 10.8725 2.99485 13.8674 6.68954 13.8674C8.34648 13.8674 9.86964 13.2602 11.0429 12.2516L11.3208 12.5397V13.3528L16.4666 18.4883L18 16.9548L12.8645 11.809ZM6.68954 11.809C4.12693 11.809 2.05832 9.74043 2.05832 7.17782C2.05832 4.61521 4.12693 2.5466 6.68954 2.5466C9.25214 2.5466 11.3208 4.61521 11.3208 7.17782C11.3208 9.74043 9.25214 11.809 6.68954 11.809Z",
    fill: "#006485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.5a5b8e0f132febe4742476ae4898d53d.svg";
export { ForwardRef as ReactComponent };